import {SettlementCurrencyModel} from '../models/settlement-currency-state.model';

export class SetSettlementCurrency {
  static readonly type = '[Settlement Currency] Set currency';

  constructor(public payload: SettlementCurrencyModel) {
  }
}
